export const APP_VERSION = "1.0.0";
export const APP_NAME = "SNIMF";
export const APP_NAME_LONG =
    "Sistema Nacional de Informação e Monitoramento de Florestas";
export const APP_LOGO_URL = "/logo/logo_dfb.png";
export const APP_LOGO_LOGIN_URL = "/logo_login/logo_dfb_green.png";
